import moment from 'moment';
// import { getArrayWeek, todayDate } from "../../../functionsDate";
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';
import { AssignmentCalendarFooter } from './AssignmentCalendarFooter';
import { AssignmentCalendarHeader } from './AssignmentCalendarHeader';
import { getArrayWeek, todayDate } from '@/utils/dateFunctions';
import { AssignmentItem } from './AssignmentItem';
import { IListTimeAssignmentsResponse, Assignment } from '@/api/timeAssignments/types';
// import { UserItem } from './AssignmentCalendarTask';

export interface IAssignmentTableProps {
  // allUsers: UserItem[]; //TODO: revisar despues
  setRange: (range: {
    dateFrom: string;
    dateTo: string;
  }) => void;
  week: string[];
  getInfo: () => void;
  assignmentsData: IListTimeAssignmentsResponse[];
  weeknumber: number;
  teamDayTotal: number[];
  teamTotalR: number;
  teamTotalE: number;
  dateFrom: moment.Moment;
  dateTo: moment.Moment;
  setDateFrom: (date: moment.Moment) => void;
  setDateTo: (date: moment.Moment) => void;
  setWeekNumber: (number: number) => void;
  setWeek: (week: string[]) => void;
  actionShowTaskDetail: (item: IListTimeAssignmentsResponse, task: Assignment) => void;
}

export const AssignmentTable = ({
  // allUsers,
  setRange,
  week,
  getInfo,
  assignmentsData,
  weeknumber,
  teamDayTotal,
  teamTotalR,
  teamTotalE,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  setWeekNumber,
  setWeek,
  actionShowTaskDetail
}: IAssignmentTableProps) => {

  const setDataWeek = (df7: moment.Moment, dt7: moment.Moment) => {
    setDateFrom(df7)
    setDateTo(dt7)
    const newRange = {
      dateFrom: df7.format("DD MMM YYYY"),
      dateTo: dt7.format("DD MMM YYYY")
    }
    setRange(newRange)
    const mo = moment(df7);
    const array = getArrayWeek(mo);
    setWeek(array)
  }

  const weekLess = () => {
    if (weeknumber > 0) {
      const df7 = dateFrom.subtract(7, 'days')
      const dt7 = dateTo.subtract(7, 'days')
      setDataWeek(df7, dt7)
      setWeekNumber(weeknumber - 1)
    }
  }

  const weekPlus = () => {
    if (weeknumber < 2) {
      const df7 = dateFrom.add(7, 'days')
      const dt7 = dateTo.add(7, 'days')
      setDataWeek(df7, dt7)
      setWeekNumber(weeknumber + 1)
    }
  }

  return (
    <div className={assignmentsStyles["assignment-table"]}>
      <div className={assignmentsStyles["assignment-header__container"]}>
        <AssignmentCalendarHeader weekLess={weekLess} weekPlus={weekPlus} week={week} todayDate={todayDate} />
      </div>
      {assignmentsData?.map((assignment: IListTimeAssignmentsResponse) => {
        return (
          <AssignmentItem
            key={assignment.username}
            item={assignment}
            getInfo={getInfo}
            week={week}
            // allUsers={allUsers}
            actionShowTaskDetail={actionShowTaskDetail}
          />
        );
      }
      )}
      <AssignmentCalendarFooter teamDayTotal={teamDayTotal} teamTotalR={teamTotalR} teamTotalE={teamTotalE} />
    </div>
  )
}